module.exports = __webpack_public_path__ + "static/img/jianlin_hover.8e5e165.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/jianlin_hover.png
// module id = 739
// module chunks = 1